import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getNoteTypeService } from './../../Services/noteTypeService'

export const reducerName = 'noteType';

const initialState = {
  request: false,
  error: null,
  data: null
};

export const getNoteType = createAsyncThunk(
  'noteType/get',
  async (a, { rejectWithValue }) => {
    try {
      
      const response = await getNoteTypeService();

      return {
        data: response
      };
    } catch (error) {
      return rejectWithValue({
        error: error.message
      })
    }
  }
);


export const noteTypeReducer = createSlice({
  name: reducerName,
  initialState,
  extraReducers: (builder) => {

    builder.addCase(getNoteType.fulfilled, (state, action) => {
      state.data = action.payload?.data;
      state.request = false;
    })

    builder.addCase(getNoteType.rejected, (state, action) => {
      state.error = action.payload.error;
      state.request = false;
      state.data = null;
    })

    builder.addCase(getNoteType.pending, (state) => {
      state.request = true;
      state.error = null;
      state.data = null;
    })
  }
});

export default noteTypeReducer.reducer;
